<template>
  <div class="System">
    <h1>系统设置 </h1>
    <p>版本号：2.0.25.1022</p>

    <p>
      更新时间：2024年10月22日
    </p>
    <p>
      持续更新中，请等待。。。。
    </p>
  </div>
</template>


<script>
export default {
  name: 'about',
  data() {
    return {
      refreshTime: 30,
      refreshTimeDis: 30
    }
  },
  mounted() {

    this.$data.refreshTime = this.$cookies.get('refreshTime')

  },
  methods: {
    click() {

      this.$cookies.set('refreshTime', this.$data.refreshTime)
      this.refreshTimeDis = this.refreshTime;
    }
  }
}
</script>

<style lang="less">
.System {
  margin: auto;


}

.dialogEdit {
  box-sizing: border-box;
  width: 40%;
  background-color: rgba(163, 178, 241, 0.7);
  border-radius: 3px;

}
</style>